import * as React from "react";
import { ObservableValue } from "azure-devops-ui/Core/Observable";
import { Checkbox } from "azure-devops-ui/Checkbox";

const firstCheckbox = new ObservableValue<boolean>(false);

export default class CheckboxExample extends React.Component {
    public render(): JSX.Element {
        return (
            <Checkbox
                onChange={(event, checked) => (firstCheckbox.value = checked)}
                checked={firstCheckbox}
                label="Basic checkbox"
            />
        );
    }
}
